module.exports = __webpack_public_path__ + "static/media/24.9b52b97d.png";